<template>
    <div class="layer alignCenter" style="z-index: 6" v-show="visible">
        <div class="mask fullSpace"></div>
        <div class="confirmBox white_bg" :class="{show : visible}"
             :style="'margin-left: ' + marginLeft + 'px; margin-top: ' + marginTop + 'px;'">

            <header class="header primaryTextColor bold" :style="titleStyle" v-show="title.length">
                {{title}}
            </header>

            <div class="body alignCenter font14r grey333" :style="contentStyle">
                <div class="paddingH8" v-html="content"></div>
            </div>

            <footer class="footer bold" @click="visible = false">

                <div class="flexLayout bold">
                    <div class="flexItem">
                        <button class="button cancelButton font14r" :style="cancelButtonStyle"
                            @click="onClickCancelButton">{{cancelText}}</button>
                    </div>
                    <div class="divide"></div>
                    <div class="flexItem">
                        <button class="button okButton font14r" :style="okButtonStyle"
                            @click="onClickOkButton">{{okText}}</button>
                    </div>

                </div>

            </footer>

        </div>
    </div>
</template>

<script>

const config = {
    defaultTitle : '提示',
    okText : '确认',
    cancelText : '取消',
};

export default {
    name: "confirmBox",
    data () {
        return {
            visible : false,
            title : '',
            content : '',
            titleStyle : '',
            contentStyle : '',
            marginLeft : 0,
            marginTop : 0,
            okText : config.okText,
            cancelText : config.cancelText,
            okButtonStyle : '',
            cancelButtonStyle : '',

            /**
             * var Function | null
             * function params
             * - result     Boolean     true for click ok, false for click cancel
             */
            callback : null
        }
    },
    methods : {
        setData : function (data) {
            for (let key in data)
            {
                this[key] = data[key];
            }
        },
        init : function (options) {
            typeof (options) == 'object' ? null : options = {};
            this.title      = options.title || config.defaultTitle;
            this.content    = options.content || '';
            this.okText     = options.okText || config.okText;
            this.cancelText = options.cancelText || config.cancelText;
            this.titleStyle         = options.titleStyle || '';
            this.contentStyle       = options.contentStyle || '';
            this.okButtonStyle      = options.okButtonStyle || '';
            this.cancelButtonStyle  = options.cancelButtonStyle || '';
        },
        show : function (options, callback) {

            this.init(options);

            typeof (callback) == 'function' ? this.callback = callback : null;

            this.visible = true;
            // show and update margin after update.
        },
        onClickOkButton : function () {
            this.callback ? this.callback(true) : null;
        },
        onClickCancelButton : function () {
            this.callback ? this.callback(false) : null;
        },

    },
    updated () {

        // calculate margin
        let confirmBox = null;
        let list = this.$el.getElementsByClassName('confirmBox');
        if (list.length)
        {
            confirmBox = list[0];
        }
        if (!confirmBox)
        {
            return;
        }
        let width   = confirmBox.offsetWidth;
        let height  = confirmBox.offsetHeight;

        this.marginLeft = 0 - width / 2;
        this.marginTop  = 0 - height / 2;
    }
}
</script>

<style lang="scss" scoped>
.confirmBox {
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 21;
    opacity: 0;

    min-width: 287px;
    max-width: 90%;
    border-radius:8px;

    transition: opacity .2s ease-in-out 0.2s;
    -webkit-transition: opacity .2s ease-out;
    -o-transition: opacity .2s ease-in-out 0.2s;
    -moz-transition: opacity .2s ease-in-out 0.2s;

    &.show {
        opacity : 1;
    }

    .header {
        padding: 16px 16px 12px;
    }
    .body {
        line-height: 1.5em;
        padding: 0 0 20px;
        border-bottom: solid 1px #F5F5F5;
    }

    .footer {

        position: relative;

        .button {
            display: block;
            width: 100%;
            height: auto;
            padding: 16px 0;
            box-sizing: border-box;
            border: none;
            background: transparent;
            text-align: center;
            font-weight: bold;
        }

        .cancelButton {
            color: hsla(0, 0%, 20%, 1);
        }

        .okButton {
            color: hsla(38, 100%, 61%, 1);
        }

        .divide {
            position: absolute;
            z-index: 1;
            width:1px;
            height:20px;
            background:rgba(238,238,238,1);
            left: 50%;
            top: 23px;

        }
    }
}

@media screen and (min-width: 720px) {

    .confirmBox {
        max-width: 640px;
    }
}
</style>
